import React from 'react';
// import ReactDOM from 'react-dom';
import { observer, inject } from 'mobx-react';
import {
  Grid,
  TextField,
  Paper,
  withStyles,
  Button,
  List,
  ListItem,
  ListItemIcon,
  Checkbox,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
  Select,
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
} from '@material-ui/core';
import PageTitle from '../../components/PageTitle/PageTitle';
import FormInputLabel from '../../components/FormInputLabelView';
// import MUIDataTable from "mui-datatables";
// import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Loader from '../../components/Loader/LoaderView';
import { withTranslation } from 'react-i18next';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import TimeField from 'react-simple-timefield';
// import moment from 'moment';
import { clearLocalStorage } from '../../utils/common';

const errRequired = 'required_field';

class AlertProfile extends React.PureComponent {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    // this.initData = this.initData;
    this.state = {
      checked: false,
      errorField: {
        name: false,
        manufacturer: false,
      },
      labelWidth: 0,
      dialogOpen: false,
      profileId: null,
    };
  }
  async componentDidMount() {
    const { id } = this.props.match.params;
    const settingProfileId = Number(id);
    await this.props.settingProfile.getSettingProfileById(settingProfileId);
    // await this.props.router.getRouters();
    await this.props.area.getAreas();
  }

  goBack() {
    this.props.settingProfile.setAction('action', true);
    this.props.history.goBack();
    this.props.settingProfile.resetData();
  }

  handleChange = (name) => (event) => {
    this.props.settingProfile.changeData(name, event.target.checked ? 1 : 0);
  };

  // handleSelectChange = (name) => (event) => {
  //   if (name === "intoAreaRID") {
  //     this.props.settingProfile.changeData(name, event);
  //   } else {
  //     this.props.settingProfile.changeData(name, event.target.value);
  //   }
  // };

  handleSelectChange = (name) => (event) => {
    if (name === 'intoAreaRID') {
      this.props.settingProfile.changeData(name, event);
    } else if (name === 'intoBuilding') {
      let value = [];
      event.map((val) => {
        value.push(val.value);
        return true;
      });
      this.props.settingProfile.changeData(name, value);
    } else if (name === 'outOfBuilding') {
      let value = [];
      event.map((val) => {
        value.push(val.value);
        return true;
      });
      this.props.settingProfile.changeData(name, value);
    } else {
      this.props.settingProfile.changeData(name, event.target.value);
    }
  };

  handleTimeChange = (event, value) => {
    this.props.settingProfile.changeData(event, value);
  };

  handleTextChange = (name) => (event) => {
    this.clearErrorField(name);
    this.props.settingProfile.changeData(name, event.target.value);
  };

  onSubmitSettingProfile(data) {
    const path = this.props.match.path.replace('/app/alertprofile/:id/', '');
    if (this.validate()) {
      path === 'edit' ? this.handleEditSettingProfile(data.id) : this.handleCreateSettingProfile();
    }
    // path === 'edit' ? this.props.patient.patientUpdate(data) : this.props.patient.patientCreate(data)
  }

  handleCreateSettingProfile = async () => {
    const { t } = this.props;
    try {
      const result = await this.props.settingProfile.settingCreate();
      if (result.statusCode === 200) {
        Swal.fire({ html: `<h4>${t('create_success')}`, type: 'success' }).then(async (resultSuccess) => {
          if (resultSuccess.value) {
            this.props.history.push('../alertprofile');
            this.props.settingProfile.resetData();
          } else {
            Swal.fire({
              html: `<h4>${t('failed_to_create')}`,
              type: 'error',
            });
          }
        });
      }
    } catch (e) {
      if (e.statusCode === 401) {
        // Swal.fire({ html: `<h4>${e.error.message}`, type: "error" , showConfirmButton: false});
        clearLocalStorage();
        window.location.href = '/login';
      } else if (e.statusCode === 400) {
        const msg = e.error.message || t('failed_to_create');
        Swal.fire({ html: `<h4>${msg}`, type: 'error' });
      } else {
        Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
      }
    }
  };

  handleEditSettingProfile = async (id) => {
    const { t } = this.props;
    Swal.fire({
      html: `<h4>${t('edit_patient')}?`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: `${t('edit')}`,
      cancelButtonText: `${t('cancel')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.settingProfile.settingUpdate(id);
          if (result.statusCode === 200) {
            Swal.fire({
              html: `<h4>${t('update_success')}`,
              type: 'success',
            }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                this.props.settingProfile.setAction('action', true);
                this.props.history.push('../../alertprofile');
                this.props.settingProfile.resetData();
              } else {
                Swal.fire({
                  html: `<h4>${t('failed_to_update')}`,
                  type: 'error',
                });
              }
            });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else if (e.statusCode === 400) {
            const msg = e.error.message || t('failed_to_update');
            Swal.fire({ html: `<h4>${msg}`, type: 'error' });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
          }
        }
      }
    });
  };

  validate() {
    const { data } = this.props.settingProfile.toJS();
    let checkName = !data.name ? true : false;

    this.setState({
      errorField: {
        name: {
          flag: checkName,
          msg: errRequired,
        },
      },
    });
    return !checkName;
  }

  clearErrorField(key) {
    if (key === 'name') {
      this.setState({
        errorField: {
          ...this.state.errorField,
          name: {
            flag: false,
            msg: '',
          },
        },
      });
    }
  }

  renderSettingProfile() {
    const { classes, t } = this.props;
    const path = this.props.match.path.replace('/app/alertprofile/:id/', '');
    const { data, loading } = this.props.settingProfile.toJS();
    const { areas } = this.props.area.toJS();

    // get list of areas
    let areasBuilding = (areas.data || []).map((val) => {
      let list = {};
      list.label = `${val.name}`;
      list.value = val.id;
      return list;
    });

    // sort Area routers by label
    areasBuilding.sort((a, b) => (a.label > b.label ? 1 : -1));

    // get list of selected intoBuilding routers
    let selectedOptionArea = (areasBuilding || []).filter(
      (val) => data.intoBuilding && data.intoBuilding.includes(val.value),
    );
    let selectedOptionOutOfBuilding = (areasBuilding || []).filter(
      (val) => data.outOfBuilding && data.outOfBuilding.includes(val.value),
    );

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          {path === 'edit' ? (
            <PageTitle title={t('edit_setting_profile')} />
          ) : (
            <PageTitle title={t('create_setting_profile')} />
          )}
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={1}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={5}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name || ''}
                onChange={this.handleTextChange('name')}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.name.flag : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.name.flag : true}
                id='component-error-text'
              >
                {t(`${this.state.errorField.name.msg}`)}
              </FormHelperText>
            </Grid>

            <Grid item xs={12}>
              <List component='nav' aria-label='folders'>
                <React.Fragment>
                  <ListItem key={1} role={undefined} divider={true} className={classes.SettingList}>
                    <ListItemIcon className='listItemIconMain'>
                      <Checkbox
                        edge='start'
                        onChange={this.handleChange('getup')}
                        checked={data.getup ? true : false}
                        value='getup'
                        id='getup'
                        color='primary'
                        tabIndex={-1}
                        disableRipple
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <Typography>{t('get_up')}</Typography>
                        </React.Fragment>
                      }
                    />
                    <ListItemSecondaryAction className='ItemSecondaryActionMain'></ListItemSecondaryAction>
                  </ListItem>
                  <ListItem key={2} role={undefined} divider={true} className={classes.SettingList}>
                    <ListItemIcon className='listItemIconMain'>
                      <Checkbox
                        edge='start'
                        onChange={this.handleChange('walkingAt')}
                        checked={data.walkingAt ? true : false}
                        value='walkingAt'
                        id='walkingAt'
                        color='primary'
                        tabIndex={-1}
                        disableRipple
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <Typography>{t('walking')}</Typography>
                        </React.Fragment>
                      }
                    />
                    <ListItemSecondaryAction className='time ItemSecondaryActionMain'>
                      <Grid container item md={6} xs={6} sm={6}>
                        <Grid container item xs={6} sm={6}>
                          <TimeField
                            // showSeconds
                            id='walkingAtStart'
                            value={data.walkingStart || '22:00'}
                            onChange={(e) => this.handleTimeChange('walkingStart', e.target.value)}
                            input={
                              <TextField
                                variant='outlined'
                                margin='dense'
                                id='time'
                                label={t('from')}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                value={data.walkingStart || '22:00'}
                                className={classes.textfield}
                              />
                            }
                          />
                        </Grid>
                        <Grid container item xs={6} sm={6}>
                          <TimeField
                            // showSeconds
                            id='walkingAtEnd'
                            style={{ marginLeft: 58 }}
                            value={data.walkingEnd || '04:00'}
                            onChange={(e) => this.handleTimeChange('walkingEnd', e.target.value)}
                            input={
                              <TextField
                                variant='outlined'
                                margin='dense'
                                id='time'
                                label={t('to')}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                value={data.walkingEnd || '04:00'}
                                className={classes.textfield}
                              />
                            }
                          />
                        </Grid>
                      </Grid>
                    </ListItemSecondaryAction>
                  </ListItem>

                  <ListItem key={3} role={undefined} divider={true} className={classes.SettingList}>
                    <ListItemIcon className='listItemIconMain'>
                      <Checkbox
                        edge='start'
                        onChange={this.handleChange('movement')}
                        checked={data.movement ? true : false}
                        value='movement'
                        id='movement'
                        color='primary'
                        tabIndex={-1}
                        disableRipple
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <Typography>{t('movement')}</Typography>
                        </React.Fragment>
                      }
                    />
                    <ListItemSecondaryAction className='ItemSecondaryActionMain'>
                      <Grid container item md={6} xs={12}>
                        <Grid container item xs={6} sm={6}>
                          <FormControl variant='outlined' fullWidth className={classes.formSelect}>
                            <InputLabel
                              htmlFor='outlined-movementLevel'
                              margin='dense'
                              className={classes.textLabelSelect}
                            >
                              {t('sensitivity')}
                            </InputLabel>
                            <Select
                              native
                              value={data.movementLevel || 1}
                              onChange={this.handleSelectChange('movementLevel')}
                              className={classes.selectOption}
                              margin='dense'
                              input={
                                <OutlinedInput
                                  labelWidth={0}
                                  name='movementLevel'
                                  id='outlined-movementLevel'
                                  margin='dense'
                                />
                              }
                            >
                              <option value={1} label={t('low')}></option>
                              <option value={2} label={t('medium')}></option>
                              <option value={3} label={t('high')}></option>
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </ListItemSecondaryAction>
                  </ListItem>

                  <React.Fragment>
                    <ListItem key={6} role={undefined} divider={true} className={classes.SettingList}>
                      <ListItemIcon className='listItemIconMain'>
                        <Checkbox
                          edge='start'
                          onChange={this.handleChange('notTurnFor')}
                          checked={data.notTurnFor ? true : false}
                          value='notTurnFor'
                          id='notTurnFor'
                          color='primary'
                          tabIndex={-1}
                          disableRipple
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <React.Fragment>
                            <Typography>{t('not_turn_for')}</Typography>
                          </React.Fragment>
                        }
                      />
                      <ListItemSecondaryAction className='ItemSecondaryActionMain'>
                        <Grid container item md={6} xs={6} sm={6}>
                          <Grid container item xs={6} sm={6}>
                            <FormControl variant='outlined' fullWidth className={classes.formSelect}>
                              <InputLabel
                                htmlFor='filled-age-native-simple'
                                margin='dense'
                                className={classes.textLabelSelect}
                              >
                                {t('hours')}
                              </InputLabel>
                              <Select
                                native
                                className={classes.selectOption}
                                value={data.notTurnForHours || 0}
                                onChange={this.handleSelectChange('notTurnForHours')}
                                margin='dense'
                                input={
                                  <OutlinedInput
                                    labelWidth={0}
                                    name='notTurnForHours'
                                    id='filled-notTurnForHours'
                                    margin='dense'
                                  />
                                }
                              >
                                <option value={0}>0</option>
                                <option value={1}>1</option>
                                <option value={2}>2</option>
                                <option value={3}>3</option>
                                <option value={4}>4</option>
                                <option value={5}>5</option>
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid container item xs={6} sm={6}>
                            <FormControl
                              variant='outlined'
                              fullWidth
                              className={classes.formSelect}
                              style={{ marginLeft: 65 }}
                            >
                              <InputLabel
                                htmlFor='filled-age-native-simple'
                                margin='dense'
                                className={classes.textLabelSelect}
                              >
                                {t('minutes')}
                              </InputLabel>
                              <Select
                                native
                                className={classes.selectOption}
                                value={data.notTurnForMinutes || 0}
                                onChange={this.handleSelectChange('notTurnForMinutes')}
                                margin='dense'
                                input={
                                  <OutlinedInput
                                    labelWidth={0}
                                    name='notTurnForMinutes'
                                    id='filled-notTurnForMinutes'
                                    margin='dense'
                                  />
                                }
                              >
                                <option value={0}>0</option>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={30}>30</option>
                                <option value={40}>40</option>
                                <option value={50}>50</option>
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <ListItem key={7} role={undefined} divider={true} className={classes.SettingList}>
                      <ListItemIcon className='listItemIconMain'>
                        <Checkbox
                          edge='start'
                          onChange={this.handleChange('noMovementFor')}
                          checked={data.noMovementFor ? true : false}
                          value='noMovementFor'
                          id='noMovementFor'
                          color='primary'
                          tabIndex={-1}
                          disableRipple
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <React.Fragment>
                            <Typography>{t('no_movement')}</Typography>
                          </React.Fragment>
                        }
                      />
                      <ListItemSecondaryAction className='ItemSecondaryActionMain'>
                        <Grid container item md={6} xs={12}>
                          <Grid container item xs={6} sm={6}>
                            <FormControl variant='outlined' fullWidth className={classes.formSelect}>
                              <InputLabel
                                htmlFor='filled-age-native-simple'
                                margin='dense'
                                className={classes.textLabelSelect}
                              >
                                {t('days')}
                              </InputLabel>
                              <Select
                                native
                                className={classes.selectOption}
                                value={data.noMovementForDay || 1}
                                onChange={this.handleSelectChange('noMovementForDay')}
                                margin='dense'
                                input={
                                  <OutlinedInput
                                    labelWidth={0}
                                    name='noMovementForDay'
                                    id='filled-noMovementForDay'
                                    margin='dense'
                                  />
                                }
                              >
                                <option value={1}>1</option>
                                <option value={2}>2</option>
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <ListItem key={8} role={undefined} divider={true} className={classes.SettingList}>
                      <ListItemIcon className='listItemIconMain'>
                        <Checkbox
                          edge='start'
                          onChange={this.handleChange('fall')}
                          checked={data.fall ? true : false}
                          value='fall'
                          id='fall'
                          color='primary'
                          tabIndex={-1}
                          disableRipple
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <React.Fragment>
                            <Typography>{t('fall')}</Typography>
                          </React.Fragment>
                        }
                      />
                      <ListItemSecondaryAction className='ItemSecondaryActionMain'> </ListItemSecondaryAction>
                    </ListItem>
                  </React.Fragment>
                  <ListItem key={9} role={undefined} divider={true} className={classes.SettingList}>
                    <ListItemIcon className='listItemIconMain'>
                      <Checkbox
                        edge='start'
                        onChange={this.handleChange('intoArea')}
                        checked={data.intoArea ? true : false}
                        value='intoArea'
                        id='intoArea'
                        color='primary'
                        tabIndex={-1}
                        disableRipple
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <Typography>{t('into')}</Typography>
                        </React.Fragment>
                      }
                    />
                    <ListItemSecondaryAction
                      className='ItemSecondaryActionMain zIndexMultiSelect'
                      style={{ fontFamily: 'Kanit,sans-serif' }}
                    >
                      <ReactMultiSelectCheckboxes
                        dropdownButton={{ width: '100%' }}
                        className='routerList'
                        options={areasBuilding}
                        onChange={this.handleSelectChange('intoBuilding')}
                        value={selectedOptionArea}
                        id='intoBuilding'
                        placeholderButtonLabel={t('area') + '...'}
                        placeholder={t('search') + '...'}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>

                  {/* <ListItem
                  key={9}
                  role={undefined}
                  divider={true}
                  className={classes.SettingList}
                >
                  <ListItemIcon className="listItemIconMain">
                    <Checkbox
                      edge="start"
                      onChange={this.handleChange("intoArea")}
                      checked={data.intoArea ? true : false}
                      value="intoArea"
                      id="intoArea"
                      color="primary"
                      tabIndex={-1}
                      disableRipple
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <React.Fragment>
                        <Typography>{t("in_to_area")}</Typography>
                      </React.Fragment>
                    }
                  />
                  <ListItemSecondaryAction
                    className="ItemSecondaryActionMain zIndexList"
                    style={{ fontFamily: "Kanit,sans-serif" }}
                  >
                    <ReactMultiSelectCheckboxes
                      dropdownButton={{ width: "100%" }}
                      className="routerList"
                      options={routersNormal}
                      onChange={this.handleSelectChange("intoAreaRID")}
                      value={selectedOption}
                      id="intoAreaRID"
                    />
                  </ListItemSecondaryAction>
                </ListItem> */}

                  <React.Fragment>
                    <ListItem key={10} role={undefined} divider={true} className={classes.SettingList}>
                      <ListItemIcon className='listItemIconMain'>
                        <Checkbox
                          edge='start'
                          onChange={this.handleChange('outOfArea')}
                          checked={data.outOfArea ? true : false}
                          value='outOfArea'
                          id='outOfArea'
                          color='primary'
                          tabIndex={-1}
                          disableRipple
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <React.Fragment>
                            <Typography>{t('outOf')}</Typography>
                          </React.Fragment>
                        }
                      />
                      <ListItemSecondaryAction
                        className='ItemSecondaryActionMain zIndexList'
                        style={{ fontFamily: 'Kanit,sans-serif' }}
                      >
                        <ReactMultiSelectCheckboxes
                          dropdownButton={{ width: '100%' }}
                          className='routerList'
                          options={areasBuilding}
                          onChange={this.handleSelectChange('outOfBuilding')}
                          value={selectedOptionOutOfBuilding}
                          id='outOfBuilding'
                          placeholderButtonLabel={t('area') + '...'}
                          placeholder={t('search') + '...'}
                          isOpen={false}
                          styles={customStyles}
                        />
                        {/* {'** Default : '}
                      {(routersDefault || []).map((val,i) => (
                        <span key={val.id}>{`${val.name || ' - '}`}{routersDefaultRow !== i+1 && ' , '}</span> 
                      ))}
                      {' **'} */}
                      </ListItemSecondaryAction>
                    </ListItem>

                    {/* <ListItem
                    key={10}
                    role={undefined}
                    className={classes.SettingList}
                  >
                    <ListItemIcon className="listItemIconMain">
                      <Checkbox
                        edge="start"
                        onChange={this.handleChange("outOfArea")}
                        // checked={data.outOfArea}
                        checked={true}
                        value="outOfArea"
                        id="outOfArea"
                        color="primary"
                        tabIndex={-1}
                        disableRipple
                        disabled
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <Typography>{t("out_of_area")}</Typography>
                        </React.Fragment>
                      }
                    />
                    <ListItemSecondaryAction className="ItemSecondaryActionMain selectList">
                      <Typography color="textSecondary">
                        {`** ${t("default")} : `}
                        {(routersDefault || []).map((val, i) => (
                          <span key={val.id}>
                            {`${val.name || " - "}`}
                            {routersDefaultRow !== i + 1 && " , "}
                          </span>
                        ))}
                        {" **"}
                      </Typography>
                    </ListItemSecondaryAction>
                  </ListItem> */}

                    <ListItem key={4} role={undefined} divider={true} className={classes.SettingList}>
                      <ListItemIcon className='listItemIconMain'>
                        <Checkbox
                          edge='start'
                          onChange={this.handleChange('lowBattery')}
                          checked={data.lowBattery ? true : false}
                          value='lowBattery'
                          id='lowBattery'
                          color='primary'
                          tabIndex={-1}
                          disableRipple
                          disabled
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <React.Fragment>
                            <Typography>{t('low_battery')}</Typography>
                          </React.Fragment>
                        }
                      />
                      <ListItemSecondaryAction className='ItemSecondaryActionMain'> </ListItemSecondaryAction>
                    </ListItem>
                  </React.Fragment>

                  <ListItem key={5} role={undefined} divider={true} className={classes.SettingList}>
                    <ListItemIcon className='listItemIconMain'>
                      <Checkbox
                        edge='start'
                        onChange={this.handleChange('noSignal')}
                        checked={data.noSignal ? true : false}
                        value='noSignal'
                        id='noSignal'
                        color='primary'
                        tabIndex={-1}
                        disableRipple
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <Typography>{t('no_signal')}</Typography>
                        </React.Fragment>
                      }
                    />
                    <ListItemSecondaryAction className='ItemSecondaryActionMain'></ListItemSecondaryAction>
                  </ListItem>
                </React.Fragment>
              </List>
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.onSubmitSettingProfile(data)}
                  className={classes.button}
                >
                  {path === 'edit' ? `${t('edit')}` : `${t('create')}`}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  renderView() {
    const { classes, t } = this.props;
    const { data, loading } = this.props.settingProfile.toJS();
    // const { routers } = this.props.router.toJS();

    const { areas } = this.props.area.toJS();

    // get list of areas
    let areasBuilding = (areas.data || []).map((val) => {
      let list = {};
      list.label = `${val.name}`;
      list.value = val.id;
      return list;
    });

    // sort Area routers by label
    areasBuilding.sort((a, b) => (a.label > b.label ? 1 : -1));

    // get list of selected intoBuilding routers
    let selectedOptionArea = (areasBuilding || []).filter(
      (val) => data.intoBuilding && data.intoBuilding.includes(val.value),
    );
    let selectedOptionOutOfBuilding = (areasBuilding || []).filter(
      (val) => data.outOfBuilding && data.outOfBuilding.includes(val.value),
    );

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('view_setting_profile')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={1}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={5}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name || ''}
                onChange={this.handleTextChange('name')}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.name.flag : false}
                disabled
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.name.flag : true}
                id='component-error-text'
              >
                {t(`${this.state.errorField.name.msg}`)}
              </FormHelperText>
            </Grid>

            <Grid item xs={12}>
              <List component='nav' aria-label='folders'>
                <React.Fragment>
                  <ListItem key={1} role={undefined} divider={true} className={classes.SettingList}>
                    <ListItemIcon className='listItemIconMain'>
                      <Checkbox
                        edge='start'
                        onChange={this.handleChange('getup')}
                        checked={data.getup ? true : false}
                        value='getup'
                        id='getup'
                        color='primary'
                        tabIndex={-1}
                        disableRipple
                        disabled
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <Typography>{t('get_up')}</Typography>
                        </React.Fragment>
                      }
                    />
                    <ListItemSecondaryAction className='ItemSecondaryActionMain'></ListItemSecondaryAction>
                  </ListItem>
                  <ListItem key={2} role={undefined} divider={true} className={classes.SettingList}>
                    <ListItemIcon className='listItemIconMain'>
                      <Checkbox
                        edge='start'
                        onChange={this.handleChange('walkingAt')}
                        checked={data.walkingAt ? true : false}
                        value='walkingAt'
                        id='walkingAt'
                        color='primary'
                        tabIndex={-1}
                        disableRipple
                        disabled
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <Typography>{t('walking')}</Typography>
                        </React.Fragment>
                      }
                    />
                    <ListItemSecondaryAction className='time ItemSecondaryActionMain'>
                      <Grid container item md={6} xs={6} sm={6}>
                        <Grid container item xs={6} sm={6}>
                          <TimeField
                            // showSeconds
                            id='walkingAtStart'
                            value={data.walkingStart || '22:00'}
                            onChange={(e) => this.handleTimeChange('walkingStart', e.target.value)}
                            input={
                              <TextField
                                variant='outlined'
                                margin='dense'
                                id='time'
                                label={t('from')}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                value={data.walkingStart || '22:00'}
                                className={classes.textfield}
                                disabled
                              />
                            }
                          />
                        </Grid>
                        <Grid container item xs={6} sm={6}>
                          <TimeField
                            // showSeconds
                            id='walkingAtEnd'
                            style={{ marginLeft: 58 }}
                            value={data.walkingEnd || '04:00'}
                            onChange={(e) => this.handleTimeChange('walkingEnd', e.target.value)}
                            input={
                              <TextField
                                variant='outlined'
                                margin='dense'
                                id='time'
                                label={t('to')}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                value={data.walkingEnd || '04:00'}
                                className={classes.textfield}
                                disabled
                              />
                            }
                          />
                        </Grid>
                      </Grid>
                    </ListItemSecondaryAction>
                  </ListItem>

                  <ListItem key={3} role={undefined} divider={true} className={classes.SettingList}>
                    <ListItemIcon className='listItemIconMain'>
                      <Checkbox
                        edge='start'
                        onChange={this.handleChange('movement')}
                        checked={data.movement ? true : false}
                        value='movement'
                        id='movement'
                        color='primary'
                        tabIndex={-1}
                        disableRipple
                        disabled
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <Typography>{t('movement')}</Typography>
                        </React.Fragment>
                      }
                    />
                    <ListItemSecondaryAction className='ItemSecondaryActionMain'>
                      <Grid container item md={6} xs={12}>
                        <Grid container item xs={6} sm={6}>
                          <FormControl variant='outlined' fullWidth className={classes.formSelect}>
                            <InputLabel
                              htmlFor='outlined-movementLevel'
                              margin='dense'
                              className={classes.textLabelSelect}
                            >
                              {t('sensitivity')}
                            </InputLabel>
                            <Select
                              native
                              value={data.movementLevel || 1}
                              onChange={this.handleSelectChange('movementLevel')}
                              className={classes.selectOption}
                              margin='dense'
                              input={
                                <OutlinedInput
                                  labelWidth={0}
                                  name='movementLevel'
                                  id='outlined-movementLevel'
                                  margin='dense'
                                />
                              }
                              disabled
                            >
                              <option value={1} label={t('low')}></option>
                              <option value={2} label={t('medium')}></option>
                              <option value={3} label={t('high')}></option>
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </ListItemSecondaryAction>
                  </ListItem>

                  <React.Fragment>
                    <ListItem key={6} role={undefined} divider={true} className={classes.SettingList}>
                      <ListItemIcon className='listItemIconMain'>
                        <Checkbox
                          edge='start'
                          onChange={this.handleChange('notTurnFor')}
                          checked={data.notTurnFor ? true : false}
                          value='notTurnFor'
                          id='notTurnFor'
                          color='primary'
                          tabIndex={-1}
                          disableRipple
                          disabled
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <React.Fragment>
                            <Typography>{t('not_turn_for')}</Typography>
                          </React.Fragment>
                        }
                      />
                      <ListItemSecondaryAction className='ItemSecondaryActionMain'>
                        <Grid container item md={6} xs={6} sm={6}>
                          <Grid container item xs={6} sm={6}>
                            <FormControl variant='outlined' fullWidth className={classes.formSelect}>
                              <InputLabel
                                htmlFor='filled-age-native-simple'
                                margin='dense'
                                className={classes.textLabelSelect}
                              >
                                {t('hours')}
                              </InputLabel>
                              <Select
                                native
                                className={classes.selectOption}
                                value={data.notTurnForHours || 0}
                                onChange={this.handleSelectChange('notTurnForHours')}
                                margin='dense'
                                input={
                                  <OutlinedInput
                                    labelWidth={0}
                                    name='notTurnForHours'
                                    id='filled-notTurnForHours'
                                    margin='dense'
                                  />
                                }
                                disabled
                              >
                                <option value={0}>0</option>
                                <option value={1}>1</option>
                                <option value={2}>2</option>
                                <option value={3}>3</option>
                                <option value={4}>4</option>
                                <option value={5}>5</option>
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid container item xs={6} sm={6}>
                            <FormControl
                              variant='outlined'
                              fullWidth
                              className={classes.formSelect}
                              style={{ marginLeft: 65 }}
                            >
                              <InputLabel
                                htmlFor='filled-age-native-simple'
                                margin='dense'
                                className={classes.textLabelSelect}
                              >
                                {t('minutes')}
                              </InputLabel>
                              <Select
                                native
                                className={classes.selectOption}
                                value={data.notTurnForMinutes || 0}
                                onChange={this.handleSelectChange('notTurnForMinutes')}
                                margin='dense'
                                input={
                                  <OutlinedInput
                                    labelWidth={0}
                                    name='notTurnForMinutes'
                                    id='filled-notTurnForMinutes'
                                    margin='dense'
                                  />
                                }
                                disabled
                              >
                                <option value={0}>0</option>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={30}>30</option>
                                <option value={40}>40</option>
                                <option value={50}>50</option>
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <ListItem key={7} role={undefined} divider={true} className={classes.SettingList}>
                      <ListItemIcon className='listItemIconMain'>
                        <Checkbox
                          edge='start'
                          onChange={this.handleChange('noMovementFor')}
                          checked={data.noMovementFor ? true : false}
                          value='noMovementFor'
                          id='noMovementFor'
                          color='primary'
                          tabIndex={-1}
                          disableRipple
                          disabled
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <React.Fragment>
                            <Typography>{t('no_movement')}</Typography>
                          </React.Fragment>
                        }
                      />
                      <ListItemSecondaryAction className='ItemSecondaryActionMain'>
                        <Grid container item md={6} xs={12}>
                          <Grid container item xs={6} sm={6}>
                            <FormControl variant='outlined' fullWidth className={classes.formSelect}>
                              <InputLabel
                                htmlFor='filled-age-native-simple'
                                margin='dense'
                                className={classes.textLabelSelect}
                              >
                                {t('days')}
                              </InputLabel>
                              <Select
                                native
                                className={classes.selectOption}
                                value={data.noMovementForDay || 1}
                                onChange={this.handleSelectChange('noMovementForDay')}
                                margin='dense'
                                input={
                                  <OutlinedInput
                                    labelWidth={0}
                                    name='noMovementForDay'
                                    id='filled-noMovementForDay'
                                    margin='dense'
                                  />
                                }
                                disabled
                              >
                                <option value={1}>1</option>
                                <option value={2}>2</option>
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <ListItem key={8} role={undefined} divider={true} className={classes.SettingList}>
                      <ListItemIcon className='listItemIconMain'>
                        <Checkbox
                          edge='start'
                          onChange={this.handleChange('fall')}
                          checked={data.fall ? true : false}
                          value='fall'
                          id='fall'
                          color='primary'
                          tabIndex={-1}
                          disableRipple
                          disabled
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <React.Fragment>
                            <Typography>{t('fall')}</Typography>
                          </React.Fragment>
                        }
                      />
                      <ListItemSecondaryAction className='ItemSecondaryActionMain'> </ListItemSecondaryAction>
                    </ListItem>
                  </React.Fragment>
                  <ListItem key={9} role={undefined} divider={true} className={classes.SettingList}>
                    <ListItemIcon className='listItemIconMain'>
                      <Checkbox
                        edge='start'
                        onChange={this.handleChange('intoArea')}
                        checked={data.intoArea ? true : false}
                        value='intoArea'
                        id='intoArea'
                        color='primary'
                        tabIndex={-1}
                        disableRipple
                        disabled
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <Typography>{t('into')}</Typography>
                        </React.Fragment>
                      }
                    />
                    <ListItemSecondaryAction
                      className='ItemSecondaryActionMain zIndexMultiSelect'
                      style={{ fontFamily: 'Kanit,sans-serif' }}
                    >
                      <ReactMultiSelectCheckboxes
                        dropdownButton={{ width: '100%' }}
                        className='routerList'
                        options={areasBuilding}
                        onChange={this.handleSelectChange('intoBuilding')}
                        value={selectedOptionArea}
                        id='intoBuilding'
                        placeholderButtonLabel={t('area') + '...'}
                        placeholder={t('search') + '...'}
                        isDisabled
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                  <React.Fragment>
                    <ListItem key={10} role={undefined} divider={true} className={classes.SettingList}>
                      <ListItemIcon className='listItemIconMain'>
                        <Checkbox
                          edge='start'
                          onChange={this.handleChange('outOfArea')}
                          checked={data.outOfArea ? true : false}
                          value='outOfArea'
                          id='outOfArea'
                          color='primary'
                          tabIndex={-1}
                          disableRipple
                          disabled
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <React.Fragment>
                            <Typography>{t('outOf')}</Typography>
                          </React.Fragment>
                        }
                      />
                      <ListItemSecondaryAction
                        className='ItemSecondaryActionMain zIndexList'
                        style={{ fontFamily: 'Kanit,sans-serif' }}
                      >
                        <ReactMultiSelectCheckboxes
                          dropdownButton={{ width: '100%' }}
                          className='routerList'
                          options={areasBuilding}
                          onChange={this.handleSelectChange('outOfBuilding')}
                          value={selectedOptionOutOfBuilding}
                          id='outOfBuilding'
                          placeholderButtonLabel={t('area') + '...'}
                          placeholder={t('search') + '...'}
                          isOpen={false}
                          isDisabled
                        />
                        {/* {'** Default : '}
                      {(routersDefault || []).map((val,i) => (
                        <span key={val.id}>{`${val.name || ' - '}`}{routersDefaultRow !== i+1 && ' , '}</span> 
                      ))}
                      {' **'} */}
                      </ListItemSecondaryAction>
                    </ListItem>
                    <ListItem key={4} role={undefined} divider={true} className={classes.SettingList}>
                      <ListItemIcon className='listItemIconMain'>
                        <Checkbox
                          edge='start'
                          onChange={this.handleChange('lowBattery')}
                          checked={data.lowBattery ? true : false}
                          value='lowBattery'
                          id='lowBattery'
                          color='primary'
                          tabIndex={-1}
                          disableRipple
                          disabled
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <React.Fragment>
                            <Typography>{t('low_battery')}</Typography>
                          </React.Fragment>
                        }
                      />
                      <ListItemSecondaryAction className='ItemSecondaryActionMain'> </ListItemSecondaryAction>
                    </ListItem>
                  </React.Fragment>

                  <ListItem key={5} role={undefined} divider={true} className={classes.SettingList}>
                    <ListItemIcon className='listItemIconMain'>
                      <Checkbox
                        edge='start'
                        onChange={this.handleChange('noSignal')}
                        checked={data.noSignal ? true : false}
                        value='noSignal'
                        id='noSignal'
                        color='primary'
                        tabIndex={-1}
                        disableRipple
                        disabled
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <Typography>{t('no_signal')}</Typography>
                        </React.Fragment>
                      }
                    />
                    <ListItemSecondaryAction className='ItemSecondaryActionMain'></ListItemSecondaryAction>
                  </ListItem>
                </React.Fragment>
              </List>
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  render() {
    const path = this.props.match.path.replace('/app/alertprofile/:id/', '');
    let result;
    switch (path) {
      case 'edit':
        result = this.renderSettingProfile();
        break;
      case 'view':
        result = this.renderView();
        break;
      default:
        result = this.renderSettingProfile();
        break;
    }
    return result;
  }
}

const customStyles = {
  menuList: (provided, state) => ({
    ...provided,
    height: 150,
    maxHeight: '150px',
    overflowY: 'scroll',
  }),
};
const styles = (theme) => ({
  paper: {
    padding: '24px',
    margin: '30px',
  },
  wrapContain: {
    padding: 20,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginLeft: '5px',
  },
  formInput: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    '& label': {
      transform: 'translate(0px, 7px) scale(0.7) !important',
      fontSize: '1.33rem !important',
    },
  },
  actionBox: {
    minWidth: '280px',
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  textLabelSelect: {
    marginTop: '5px',
  },
  Contentselect: {
    '& fieldset': {
      borderColor: `${theme.palette.primary.main} !important`,
      borderWidth: '2px',
      top: '4px',
    },
    '& svg': {
      top: 'calc(50% - 8px)',
    },
    '& select': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: '100%',
  },
  SettingList: {
    width: '100%',
    display: 'flex',
    position: 'relative',
    justifyContent: 'flex-start',
    textAlign: 'left',
    paddingBottom: 0,
    paddingTop: 0,
  },
  formSelect: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit,
    minWidth: 130,
    maxWidth: '100%',
  },
  selectOption: {
    '& fieldset': {
      top: '-2px',
      bottom: '2px',
    },
    '& svg': {
      top: 'calc(50% - 8px)',
    },
    '& select': {
      paddingTop: '17px',
      paddingBottom: '5px',
    },
    '&:hover, &:focus': {
      borderColor: `${theme.palette.primary.main} !important`,
    },
  },
  textfield: {
    '& fieldset': {
      top: '4px',
      bottom: '6px',
    },
    '& input': {
      marginLeft: '-2px',
    },
    '& label': {
      marginLeft: '2px',
    },
    width: '100%',
    minWidth: 145,
    paddingRight: '12px',
    paddingLeft: '4px',
  },
  textLabel: {
    color: 'rgb(0, 150, 135)',
    fontSize: '1.4rem',
  },
});

export const page = inject('settingProfile', 'router', 'area')(observer(AlertProfile));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
